import React, { useState, useRef } from "react";
import PopperContainer from "./PopperContainer";
import { makeStyles } from '@mui/styles';
import * as R from 'ramda';

import ToolsColorSelector from "./ToolsColorSelector";
import { color4ArrayToHex } from '../../utils/helpers';

import './ColorSelector.scss';


const useStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center'
  },
  inputWrapper: {
    width: 24,
    height: 24,
    borderRadius: 2,
    cursor: 'pointer',
    boxSizing: 'border-box'
  },
  label: {
    marginRight: 8
  },
  cbColorInput: {
    width: 208,
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
  }
});

interface ColorSelectorProps {
  primaryColor: string;
  onColorSelect: any;
  onColorValidate?: any;
}

const ColorSelector = ((props: ColorSelectorProps) => {

  const selectedColor = R.clone(props.primaryColor);
  const selectedColorRef = useRef(selectedColor);
  // const [selectedColor, setSelectedColor] = useState(R.clone(props.primaryColor));

  const classes = useStyles();
  const anchor = useRef(undefined);
  const [open, setOpen] = useState(false);

  const [offClickTime, setOffClickTime] = useState(0);

  const [lastSendColor, setLastSendColor] = useState(0);
  const [validateColorTimer, setValidateColorTimer] = useState(null);

  const handleColorSelect = (c) => {
    const hex = color4ArrayToHex(c);
    // console.log('selectedColor', hex);
    selectedColorRef.current = hex;
    props.onColorSelect(selectedColorRef.current);

    const now = Date.now();
    if (now - lastSendColor > 800) {
      validateColor();
      setLastSendColor(now);
      clearTimeout(validateColorTimer);
    } else {
      clearTimeout(validateColorTimer);
      setValidateColorTimer(setTimeout(() => {
        validateColor();
      }, 2000));
    }
  }

  const validateColor = () => {
    if (props.onColorValidate) {
      props.onColorValidate(selectedColorRef.current);
    }
  }

  const handleClickOff = () => {
    // validateColor(selectedColorRef.current)
    setOpen(false);
    setOffClickTime(Date.now());
  };

  const handleClick = () => {
    if (Date.now() - offClickTime < 500) {
      // avoid duplicate event
      // offclick has already set open to false
      return;
    }
    setOpen(!open);
  }


  return (
    <div style={{
      width: 150,
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
    }} ref={anchor}>
      <div className="hawk-color-picker" onClick={() => handleClick()}>
        <div className="hawk-color-picker__input-picker">
          <div className="hawk-color-picker__input-picker__color" style={{ backgroundColor: selectedColor }}></div>
          <div className="hawk-input__wrapper" data-children-count="1">
            <div className="hawk-input hawk-input__read-only">
              {selectedColor}
            </div>
          </div>
        </div>
      </div>

      <PopperContainer
        className='hawk-color-container'
        open={open}
        anchorEl={anchor.current}
        onClickOff={handleClickOff}
        placement="bottom">
        <ToolsColorSelector color={selectedColor} onColorSelect={(c) => handleColorSelect(c)} />
      </PopperContainer>
    </div>
  );

});

export default ColorSelector;